import { PerspectiveCamera } from 'three';
export default (fov, nearPlane, farPlane, startZ) => {
    const camera = new PerspectiveCamera(fov, window.innerWidth / window.innerHeight, nearPlane, farPlane);
    camera.position.setZ(startZ);
    return camera;
};
